

















































import { Component, Vue } from 'vue-property-decorator'
import _get from 'lodash/get'

@Component
export default class Group extends Vue {
  loading: boolean = false
  uploading: boolean = false
  modalVisible: boolean = false
  modalLoading: boolean = false
  modalTitle: string = 'Add Group'
  columns = [
    {
      title: 'ID',
      dataIndex: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
    },
    {
      title: 'Action',
      dataIndex: 'operation',
      fixed: 'right',
      width: 160,
      scopedSlots: { customRender: 'action' },
    },
  ]
  rules: any = {
    name: [
      { required: true, message: 'Name must not be empty', trigger: 'blur' },
    ],
  }
  form = {} as any
  isEdit: boolean = false

  get role() {
    return this.$store.state.userStore.role
  }

  get groups() {
    return this.$store.state.groupStore.groups 
  }

   get total() {
    return this.$store.state.groupStore.total
  }

  get pagination() {
    return this.$store.state.groupStore.pagination
  }

  get organizationList() {
    return this.$store.state.organizationStore.organizationList
  }

  get organization() {
    return this.$store.state.groupStore.organization
  }

  set organization(val) {
    this.$store.commit('updateCurrentGroupOrg', val)
  }

  mounted() {
    this.loading = true
    this.$store.dispatch('getGroups')
    this.$store.dispatch('getGroups', {
      page: this.pagination.current,
      limit: this.pagination.pageSize
    }).then(() => {
      this.loading = false
      this.pagination.total = this.total
    })
    .catch(() => {
      this.loading = false
    })
    if (this.role === 'admin') {
      this.rules.org = [
        { required: true, message: 'Organization must not be empty', trigger: 'blur' },
      ]
    }
  }

  updateGroups(pagination:any, filters:any, sorter:any) {
    this.loading = true
    this.$store.commit('updateGroupPagination', {current: pagination.current})
    this.$store.commit('updateGroupSorter', {field: sorter.field, order: sorter.order === 'ascend'? 'asc': 'desc'})
    this.$store.dispatch('getGroups').then(() => {
      this.loading = false
    })
  }

  search() {
    this.loading = true
    this.$store.commit('updateGroupPagination', {current: 1})
    this.$store.dispatch('getGroups').then(() => {
      this.loading = false
    })
  }

  showCreateGroup() {
    this.modalVisible = true
    this.modalTitle = 'Create Group'
    this.isEdit = false
    this.form = {}
  }

  showEditGroup(group: any) {
    this.form = { ...group }
    this.modalTitle = 'Edit Group'
    this.isEdit = true
    this.modalVisible = true
  }

  showDeletion(group: any) {
    const h = this.$createElement
    const _this = this
    this.$confirm({
      title: 'Group Delete',
      okText: 'Confirm',
      content: h('div', {}, [
        'Are you sure you want to delete ',
        h('strong', group.name),
        '?'
      ]),
      onOk() {
        _this.$store.dispatch('deleteGroup', group.id)
      }
    })
  }

  saveGroup() {
    this.modalLoading = true
    if (this.isEdit) {
      return this.$store.dispatch('updateGroup', this.form).then(() => {
        this.modalLoading = false
        this.modalVisible = false
        this.form = {}
        this.$message.success("Group Updated")
      })
      .catch(e => {
        this.modalLoading = false
        this.$message.error(JSON.stringify(_get(e, 'response.data.messages', 'Something went wrong')))
      })
    }
    else {
      return this.$store.dispatch('addGroup', this.form).then(() => {
        this.modalLoading = false
        this.modalVisible = false
        this.form = {}
        this.$message.success("Group Created")
      })
      .catch(e => {
        this.modalLoading = false
        this.$message.error(JSON.stringify(_get(e, 'response.data.messages', 'Something went wrong')))
      })
    }
  }

  cancelForm() {
    this.modalVisible = false
    this.modalLoading = false
    this.uploading = false
    this.form = {}
  }

}
